/**
 * `any` added to nested type as it otherwise was not assignable to all possible types
 *
 * Should be refined if possible in future TypeScript version
 */
export interface XMLInterfaceObject { [member: string]: string | number | boolean | null | XMLInterfaceArray | XMLInterfaceObject | undefined | any };
export interface XMLInterfaceArray extends Array<string | number | boolean | null | XMLInterfaceArray | XMLInterfaceObject> {}

/**
 * Helper for migrations from XML classes to pure JS object
 */
export class XMLInterfaceObjectFactory {
    public static CREATE_MAP_FROM_JSON(json: string): XMLInterfaceObject {
        const v = JSON.parse(json);
        if (typeof v !== 'object' || Array.isArray(v)) {
            throw new Error(`JSON was not a hash object`);
        }

        return v;
    }
}
